import React, { Component, createRef } from 'react';
import { Button, withStyles, MenuItem, ListItemText, ClickAwayListener, Grow, Paper, Popper, TextField, InputAdornment } from '@material-ui/core';
import { translate } from 'react-i18next';
import { tableToolbar } from '../../../styles/workplanStyles';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List as VirtualList } from 'react-virtualized';
import clsx from 'clsx';

const styles = theme => (tableToolbar(theme));

class CustomSelect extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = createRef();
        this.state = {
            open: false,
            searchString: '',
            list: props.data
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({ list: this.props.data });
        }
    }

    handleClose = () => {
        const { open } = this.state;

        this.setState({ open: !open });
    }

    renderRowIncluded = ({ key, index, style }) => {
        const { list } = this.state;

        const StyledMenuItem = withStyles((theme) => ({
            root: {
                width: '100%'
            },
        }))(MenuItem);

        return (
            <div style={{ ...style, display: 'flex' }}>
                <StyledMenuItem>
                    <ListItemText style={{ width: '100%' }} onClick={() => this.props.updateSelected(list[index])} primary={`${list[index].label}`} />
                </StyledMenuItem>
            </div>
        )
    }

    noRowsRenderer = () => {
        return <div className={styles.noRows}>{this.props.t('common:Text.noData')}</div>;
    }

    searchValue = (e) => {
        const { data } = this.props;
        let list = e.target.value !== '' ? data.filter(d => d.label.toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1) : data;

        this.setState({ list })
    }

    render() {
        const { icon, anchorRef, selected, clearTooltip, title, classes, disabled, t } = this.props;
        const { open, list } = this.state;

        const isDataEmpty = !list || list.length === 0;
        const isDisabled = disabled || isDataEmpty;

        let cIcon = <FontAwesomeIcon color="primary" className={classes.iconButton} icon={icon} />;
        let button = (
            <span>
                <Button
                    disabled={isDisabled}
                    className={clsx(classes.tableColumnButton, selected ? classes.buttonSelected : '', isDisabled ? classes.buttonDisabled : '')}
                    onClick={() => { clearTooltip(); this.setState({ open: !open }) }}
                >
                    {cIcon}
                </Button>
            </span>
        );

        return (
            <React.Fragment>
                <CustomToolTip enterDelay={500} leaveDelay={500} titletext={title} jsx={button} />
                <Popper
                    style={{ top: '-11px', marginLeft: 7 }}
                    open={open}
                    anchorEl={anchorRef.current}
                    placement={'bottom-start'}
                    transition
                    className={classes.popoverEeOptions}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'left bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <div className={classes.menuCustomSelect}>
                                        <TextField id="standard-search" type="search" autoFocus
                                            onChange={this.searchValue}
                                            autoComplete='off'
                                            style={{ paddingLeft: 16, width: '90%' }}
                                            placeholder={`${t('common.search')} ${title}`}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        {cIcon}
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <VirtualList style={{ width: '100%' }}
                                            width={500}
                                            height={176}
                                            rowHeight={38}
                                            rowRenderer={this.renderRowIncluded}
                                            rowCount={list.length}
                                            noRowsRenderer={this.noRowsRenderer}
                                            overscanRowCount={3}
                                        />
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment >
        )
    }
}

export default translate('workplanManager')(withStyles(styles)(CustomSelect));